import axios from "axios";

// Priority: Runtime config (static file, survives build) > Build-time env var
const BACKEND_URL =
  (typeof window !== "undefined" && window.__RUNTIME_CONFIG__?.BACKEND_URL) ||
  process.env.REACT_APP_BACKEND_URL ||
  "";

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses - only clear token on auth endpoint failures
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || "";
      if (url.includes("/auth/me")) {
        localStorage.removeItem("session_token");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { BACKEND_URL };
